import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SectionNavigation = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const [isSticky, setIsSticky] = useState(false);

  const sections = [
    { id: 'engagement-options', label: 'Engagement Options', icon: 'Grid' },
    { id: 'contact-form', label: 'General Inquiry', icon: 'MessageSquare' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      // Make navigation sticky after scrolling past hero
      setIsSticky(window.scrollY > 400);

      // Detect active section based on scroll position
      const sectionElements = sections?.map(section => ({
        id: section?.id,
        element: document.getElementById(section?.id)
      }));

      for (let i = sectionElements?.length - 1; i >= 0; i--) {
        const section = sectionElements?.[i];
        if (section?.element) {
          const rect = section?.element?.getBoundingClientRect();
          if (rect?.top <= 150) {
            setActiveSection(section?.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = window.innerWidth < 768 ? 120 : 100; // Larger offset for mobile
      const elementPosition = element?.getBoundingClientRect()?.top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`transition-all duration-300 z-40 ${
        isSticky
          ? 'fixed top-16 lg:top-20 left-0 right-0 bg-white/95 backdrop-blur-md shadow-md'
          : 'relative bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between py-3 sm:py-4">
          <div className="flex items-center space-x-2 flex-shrink-0">
            <Icon name="Navigation" size={20} className="text-secondary transition-transform duration-300 hover:scale-110 hover:rotate-12" />
            <span className="text-xs sm:text-sm font-medium text-muted-foreground hidden sm:inline">
              Quick Navigation
            </span>
          </div>
          
          {/* Mobile: Horizontal scrollable buttons */}
          <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide flex-1 ml-2 sm:ml-4">
            {sections?.map((section) => (
              <button
                key={section?.id}
                onClick={() => scrollToSection(section?.id)}
                className={`flex items-center justify-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg text-xs sm:text-sm font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 min-w-[44px] min-h-[44px] focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 ${
                  activeSection === section?.id
                    ? 'bg-secondary text-white shadow-md scale-105'
                    : 'bg-surface text-muted-foreground hover:bg-secondary/10 hover:text-secondary hover:shadow-md hover:scale-105 active:scale-95'
                }`}
                aria-label={`Navigate to ${section?.label}`}
                aria-current={activeSection === section?.id ? 'true' : 'false'}
              >
                <Icon name={section?.icon} size={16} className="flex-shrink-0 transition-transform duration-300 hover:rotate-12" />
                <span className="hidden sm:inline">{section?.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default SectionNavigation;